import {Mapper} from '@s-ui/domain'

export default class FromImagesListRawDataToImagesListValueObjectMapper extends Mapper {
  constructor({config, imagesListValueObject, imageValueObject}) {
    super()
    this._config = config
    this._urlStatics = config.get('urlStatics')
    this._emptyVehicleImage = config.get('technicalDetails').TECHNICAL_DETAILS_EMPTY_VEHICLE_IMAGE
    this._defaultImage = `${this._urlStatics}${this._emptyVehicleImage}`
    this._imagesListValueObject = imagesListValueObject
    this._imageValueObject = imageValueObject
  }

  map = ({images}) => {
    const items = images.length
      ? images.map(image => this._imageValueObject({src: image.url}))
      : [this._imageValueObject({src: this._defaultImage})]
    return this._imagesListValueObject({items})
  }
}
